import { render, staticRenderFns } from "./ImWebimSetCustomer.vue?vue&type=template&id=6d9ad538&scoped=true"
import script from "./ImWebimSetCustomer.vue?vue&type=script&lang=js"
export * from "./ImWebimSetCustomer.vue?vue&type=script&lang=js"
import style0 from "./ImWebimSetCustomer.vue?vue&type=style&index=0&id=6d9ad538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ad538",
  null
  
)

export default component.exports